import React, { useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import useGainsQCApi from '../services/useGainsQCApi';
import { ExportTable } from '../components/tables/ExportTable';
import { QCPageCards } from '../components/buttons/QCPageCards';
import { endpointContext } from '../contexts/endpointContext';
import exportConfig from '../config';
import { SiteTypeRadios } from '../components/form_comps/SiteTypeRadios';
import { formatDate } from '../helpers/formatDate';
import Skeleton from 'react-loading-skeleton';
import Select from 'react-select';
import Plot from 'react-plotly.js';
import { SkeletonTable } from '../components/tables/SkeletonTable';

const ADDITIONAL_BUTTON_STYLE = {
	height: '130px',
	width: '280px',
	marginTop: '15px'
};

export const DataChecks = (props) => {
	const endpointContextDataChecksPage = useContext(endpointContext);

	const [sortedData, setSortedData] = useState([]);
	const [commodity, setCommodity] = useState(3);

	const [selectedCommodities, setSelectedCommodities] = useState([]);
	const [selectedProdStates, setSelectedProdStates] = useState([]);
	const [selectedSiteId, setSelectedSiteId] = useState(null);
	const [selectedSiteOptions, setSelectedSiteOptions] = useState([]);
	const [siteOptions, setSiteOptions] = useState([]);

	const formValid =
		(selectedCommodities.length > 0 && selectedProdStates.length > 0) ||
		selectedSiteOptions.length > 0
			? true
			: false;

	const fetchExportStatus = useGainsQCApi();
	const exportSteelSites = useGainsQCApi();
	const checkGapsInData = useGainsQCApi();
	const fetchSites = useGainsQCApi();

	const commodities =
		endpointContextDataChecksPage?.dbData?.allCommodities.length > 0
			? endpointContextDataChecksPage?.dbData?.allCommodities
			: [];

	useEffect(() => {
		// on mount
		fetchingSites();
	}, []);

	useEffect(() => {
		if (fetchSites.data) {
			setSiteOptions(
				fetchSites?.data?.data?.map(({ id, name, commodity_id }) => ({
					value: id,
					label: `${id}: ${name}`,
					comm: commodity_id
				}))
			);
		}
	}, [fetchSites.data, fetchSites.error]);

	const fetchingSites = async () => {
		fetchSites.makeRequest(`/smelters/sites`, 'GET', null, 'sites', 0);
	};

	const checkExportStatus = async () => {
		await fetchExportStatus.makeRequest(
			'/export/steel/status',
			'GET',
			null,
			'export status ..',
			undefined,
			undefined,
			undefined,
			'gainsApi'
		);
	};

	const exportSteel = async () => {
		await exportSteelSites.makeRequest(
			'/export/steel',
			'GET',
			null,
			'exporting steel ..',
			undefined,
			undefined,
			undefined,
			'gainsApi'
		);
	};

	const checkingGapsInData = async () => {
		fetchExportStatus.resetData();
		exportSteelSites.resetData();
		checkGapsInData.resetData();

		let body = {};
		if (selectedSiteOptions.length > 0) {
			body = {
				siteIds: selectedSiteOptions.map((opt) => opt.value).join(',')
			};
		} else {
			body = {
				commodityIds: selectedCommodities.join(','),
				prodStates: selectedProdStates.join(',')
			};
		}

		console.log("body", body)

		await checkGapsInData.makeRequest(
			'/smelters/check_gaps',
			'POST',
			body,
			'looking for data gaps ..'
		);
	};

	const handleProdStateChange = (target) => {
		checkGapsInData.resetData();
		setSelectedProdStates((prev) =>
			prev.includes(target)
				? prev.filter((item) => item !== target)
				: [...prev, target]
		);
	};

	const handleCommodityChange = (target) => {
		checkGapsInData.resetData();
		setSelectedCommodities((prev) =>
			prev.includes(target)
				? prev.filter((item) => item !== target)
				: [...prev, target]
		);
	};

	const handleSelectedSiteOptions = (selectedOptions) => {
		checkGapsInData.resetData();
		setSelectedSiteOptions(selectedOptions);
	};

	const renderDataChecksTable = () => {
		if (checkGapsInData.loading) {
			<>
				<h4>Gaps</h4>
				<div
					className="table table-responsive"
					style={{ width: '600px', height: '300px' }}
				>
					<table className="captureTable">
						<thead>
							<tr>
								<th>Site ID</th>
								<th>Earliest gap</th>
								<th>Gap size</th>
							</tr>
						</thead>

						<tbody>
							{Array(4)
								.fill(null)
								.map((_, index) => (
									<tr key={index}>
										<td>
											<Skeleton />
										</td>
										<td>
											<Skeleton />
										</td>
										<td>
											<Skeleton />
										</td>
										<td>
											<Skeleton />
										</td>
									</tr>
								))}
						</tbody>
					</table>
				</div>
			</>;
		}

		if (checkGapsInData?.data?.data === 'No gaps found!') {
			return <h4>No gaps found in the data for this criteria.</h4>;
		}

		if (checkGapsInData?.data?.data && !checkGapsInData?.loading) {
			return (
				<>
					<h4>Gaps</h4>
					<div
						className="table table-responsive"
						style={{ width: '600px', height: '300px' }}
					>
						<table className="captureTable">
							<thead>
								<tr>
									<th>Site ID</th>
									<th>Earliest gap</th>
									<th>Gap size</th>
								</tr>
							</thead>

							<tbody>
								{checkGapsInData?.data?.data.map((item, idx) => (
									<tr key={idx}>
										<td>{item.id}</td>
										<td>{item.missing_date_start}</td>
										<td>{item.gaps}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</>
			);
		}
	};

	const data = [
		{
			id: 901,
			missing_date_start: '2024-12-19',
			gaps: 1
		},
		{
			id: 901,
			missing_date_start: '2025-02-25',
			gaps: 2
		},
		{
			id: 901,
			missing_date_start: '2025-03-28',
			gaps: 224
		},
		{
			id: 930,
			missing_date_start: '2024-12-19',
			gaps: 1
		},
		{
			id: 930,
			missing_date_start: '2025-02-25',
			gaps: 2
		}
	];

	const earliestGapBySite = Object.values(
		data.reduce((acc, item) => {
			if (
				!acc[item.id] ||
				item.missing_date_start < acc[item.id].missing_date_start
			) {
				acc[item.id] = item;
			}

			return acc;
		}, {})
	).sort(
		(a, b) => new Date(a.missing_date_start) - new Date(b.missing_date_start)
	);

	return (
		<>
			{props.authProps.isAuthenticated ? (
				<div className="col px-0">
					<div className="contentContainer">
						<hr style={{ marginTop: '58px' }}></hr>
						<h2>QC Data Checks</h2>
						<h5>Use this page to perform data checks for QC</h5>

						<div className="row d-flex justify-content-center justify-content-md-start mt-5">
							<>
								<h2>Export status</h2>
								<div className="col-10 col-sm-6 col-md-6 col-lg-4 col-xl-3 my-2 my-lg-0">
									<QCPageCards
										onClickFunction={() => checkExportStatus()}
										dataTTID={'exportStatusTTQCReports'}
										additionalStyle={ADDITIONAL_BUTTON_STYLE}
										cardTitle={'Check export status'}
										// cardText={`check export status of ${
										// 	commodities.filter((c) => c.id === commodity)[0].name
										// }`}
										cardText={
											<div>
												check export status of <strong>steel</strong>
											</div>
										}
										cardIcon={
											<i className="fa-solid fa-clipboard-check ps-3"></i>
										}
									/>{' '}
									<Tooltip
										id="exportStatusTTQCReports"
										place="bottom"
										effect="solid"
										style={{ zIndex: '9999' }}
									>
										View status of last export of data to S3. <br></br> Click
										'Export sites' to perform another export and update the
										data.<br></br> It will take a few minutes to run, and this
										button can be clicked again to view the update.
									</Tooltip>
								</div>
								<div className="col-10 col-sm-6 col-md-6 col-lg-4 col-xl-3 my-2 my-lg-0">
									<QCPageCards
										onClickFunction={() => exportSteel()}
										dataTTID={'exportSteelTT'}
										additionalStyle={ADDITIONAL_BUTTON_STYLE}
										cardTitle={'Export sites'}
										// cardText={`export ${
										// 	commodities.filter((c) => c.id === commodity)[0].name
										// } sites`}
										cardText={
											<div>
												export <strong>steel</strong> sites
											</div>
										}
										cardIcon={<i className="fa-solid fa-file-export ps-3"></i>}
									/>{' '}
									<Tooltip
										id="exportSteelTT"
										place="bottom"
										effect="solid"
										style={{ zIndex: '9999' }}
									>
										Export all data for steel from 01-03-2016 to{' '}
										{formatDate(
											new Date(
												Date.now() - 2 * 24 * 60 * 60 * 1000
											).toISOString()
										)}
									</Tooltip>
									{exportSteelSites.data?.message ===
										'Export steel data has been requested.' && (
										<p>
											<i className="fa-solid fa-square-check me-2"></i> Export
											steel data has been requested.
										</p>
									)}
								</div>
							</>
						</div>

						{fetchExportStatus?.data?.data && (
							<div className="row mt-1">
								<div className="col-8">
									<ExportTable exportStatus={fetchExportStatus} />
								</div>
							</div>
						)}

						<div className="row d-flex justify-content-start justify-content-md-start mt-5">
							<div className="col">
								<div className="row d-flex justify-content-center justify-content-md-start ">
									<h2>Data checks</h2>
									<div className="col-10 col-sm-6 col-md-6 col-lg-4 col-xl-3 my-lg-0">
										<QCPageCards
											onClickFunction={() => checkingGapsInData()}
											dataTTID={'checkGapsTT'}
											additionalStyle={ADDITIONAL_BUTTON_STYLE}
											cardTitle={'Check data gaps'}
											cardText={<div>check gaps in data</div>}
											cardIcon={
												<i className="fa-solid fa-arrows-left-right-to-line ps-3"></i>
											}
											disabled={!formValid}
										/>
										<Tooltip
											id="checkGapsTT"
											place="bottom"
											effect="solid"
											style={{ zIndex: '9999' }}
										>
											{!formValid
												? 'Disabled: You must select one or more sites OR a selection of commodities and production states'
												: 'Check for gaps in the uploaded data'}
										</Tooltip>
									</div>
								</div>
							</div>

							<div className="col mt-4">
								<h5>Site IDs</h5>
								<div className="pe-5">
									{fetchSites.loading && siteOptions !== null ? (
										<Select
											isMulti
											isDisabled
											placeholder="Loading sites .."
											style={{ zIndex: '9999' }}
										/>
									) : siteOptions !== null && siteOptions.length === 0 ? (
										<Select
											isMulti
											isDisabled
											placeholder="No sites for given criteria"
											style={{ zIndex: '9999' }}
										/>
									) : (
										<Select
											isMulti
											options={siteOptions}
											value={selectedSiteOptions}
											onChange={handleSelectedSiteOptions}
											isSearchable
											placeholder={`Search sites (${siteOptions.length})...`}
											style={{ zIndex: '9999' }}
										/>
									)}
								</div>
							</div>

							<div className="col d-flex flex-row">
								<div
									className="d-flex flex-column mt-4 me-5"
									data-tooltip-id="unselect-site-ids-comms"
								>
									<h5>Commodities</h5>
									{commodities
										.filter((comm) => comm.siteTypeId === 1)
										.map((comm, idx) => (
											<div className="d-flex flex-row">
												<input
													className="form-check-input"
													type="checkbox"
													name="data-checks-commodity"
													id={`data-checks-commodity-${comm.commodity}`}
													value={comm.id}
													checked={selectedCommodities.includes(comm.id)}
													data-tooltip-id={`data-checks-commodity-${comm.commodity}`}
													onChange={(e) => handleCommodityChange(comm.id)}
													disabled={selectedSiteOptions.length > 0}
												></input>

												<label
													className={`form-check-label ms-2 ${
														selectedCommodities.length === commodities?.length
															? 'form-check-label-alt me-5'
															: ''
													}`}
													htmlFor={`data-checks-commodity-${comm.id}`}
													data-tooltip-id={`data-checks-commodity-${comm.commodity}`}
												>
													{comm.name}
												</label>
											</div>

											// <>
											// 	<input
											// 		id={`id${comm.index}`}
											// 		type="radio"
											// 		name="data-checks-page-comms-radios"
											// 		key={idx}
											// 		value={comm.id}
											// 		className="form-check-input"
											// 		checked={commodity === comm.id}
											// 		onClick={() => setCommodity(comm.id)}
											// 		data-tooltip-id="QCReportChangeComm"
											// 	></input>
											// 	<label
											// 		for={`id${comm.id}`}
											// 		className="form-label ms-1 me-4 my-0"
											// 		onClick={() => setCommodity(comm.id)}
											// 	>
											// 		{comm.name}
											// 	</label>
											// </>
										))}

									{selectedSiteOptions.length > 0 && (
										<Tooltip id={`unselect-site-ids-comms`}>
											Unselect all site IDs to enable commodity selection
										</Tooltip>
									)}
								</div>

								<div
									className="d-flex flex-column mt-4 ms-4"
									data-tooltip-id="unselect-site-ids-prod-state"
								>
									<h5>Production States</h5>
									{exportConfig.production_states.map((state, idx) => (
										<div key={idx} className="d-flex form-check">
											<input
												className={`form-check-input me-2 ${
													selectedProdStates.length === 6
														? 'form-check-input-alt'
														: ''
												}`}
												type="checkbox"
												name="captures-site-production-state"
												id={`captures-site-prod-state-${state.state}`}
												value={state.state}
												checked={selectedProdStates.includes(state.state)}
												data-tooltip-id={`captures-site-prod-state-${state.state}`}
												onChange={(e) => handleProdStateChange(state.state)}
												disabled={selectedSiteOptions.length > 0}
											></input>

											<label
												className={`form-check-label me-5 ${
													selectedProdStates.length === 6
														? 'form-check-label-alt me-5'
														: ''
												}`}
												htmlFor={`captures-site-prod-state-${state.state}`}
												data-tooltip-id={`captures-site-prod-state-${state.state}`}
											>
												{state.state}
											</label>

											<Tooltip id={`captures-site-prod-state-${state.state}`}>
												Production state {state.state}
												<br></br> {state.descript}
											</Tooltip>
										</div>
									))}

									{selectedSiteOptions.length > 0 && (
										<Tooltip id={`unselect-site-ids-prod-state`}>
											Unselect all site IDs to enable production state selection
										</Tooltip>
									)}
								</div>
							</div>

							{commodities &&
							fetchSites?.data?.data &&
							selectedSiteOptions.length > 0 ? (
								<p className="ms-2">
									Check gaps in ({selectedSiteOptions.length}) sites:{' '}
									<strong>
										{selectedSiteOptions.length > 0
											? selectedSiteOptions.map((item) => item.value).join(', ')
											: 'none selected'}
									</strong>
								</p>
							) : (
								<p className="ms-2">
									Check gaps for commodities:{' '}
									<strong>
										{selectedCommodities.length > 0
											? selectedCommodities
													.map(
														(comm) =>
															commodities.find((c) => c.id === comm)?.name
													)
													.join(', ')
											: 'none selected'}
									</strong>
									<br></br> and production states:{' '}
									<strong>
										{selectedProdStates.length > 0
											? selectedProdStates.join(', ')
											: 'none selected'}
									</strong>
								</p>
							)}
						</div>

						{renderDataChecksTable()}
					</div>
				</div>
			) : (
				<Navigate to="/login" />
			)}
		</>
	);
};
